import Api from "../../utils/config/api";
import { toastr } from "react-redux-toastr";
import {
  SET_QR_TEMPLATE,
  GENERATE_QR_CODE,
  SET_QR_CODE_STATE,
  SET_QR_OBJECTIVES_DATA,
} from "../types";

// for templates

export const setQrCodeTemplate = (data) => (dispatch) =>
  dispatch({
    type: SET_QR_TEMPLATE,
    payload: data,
  });

export const getQrCodeTemplate = (uniqueId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/qr-code/template/${uniqueId}`)
      .then((res) => {
        dispatch(setQrCodeTemplate(res.data.payload));
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const getQrCodeObjectives = (entityId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/qr-code/all-templates/${entityId}`)
      .then((res) => {
        dispatch({
          type: SET_QR_OBJECTIVES_DATA,
          payload: res.data.payload,
        });
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

// for setup

export const setQrCodeData = (data) => (dispatch) =>
  dispatch({
    type: SET_QR_CODE_STATE,
    payload: data,
  });

export const getQrCodeData = (qrId, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/qr-code/qr-code/${qrId}${isCache ? "?cache=true" : ""}`)
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));
        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const updateNameAndInitializeQr = (data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/qr-code/update-qr-code${isCache ? "?cache=true" : ""}`, data)
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const collectCustomerDetails = (qrId, data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/qr-code/collect-customer-details/${qrId}${
        isCache ? "?cache=true" : ""
      }`,
      data
    )
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateQrReward = (qrId, data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/qr-code/update-rewards/${qrId}${isCache ? "?cache=true" : ""}`,
      data
    )
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateQrTerms = (qrId, data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/qr-code/update-terms/${qrId}${isCache ? "?cache=true" : ""}`,
      data
    )
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateQrWhatsappDetails = (qrId, data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/qr-code/update-whatsapp-details/${qrId}${
        isCache ? "?cache=true" : ""
      }`,
      data
    )
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateQrStores = (qrId, data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/qr-code/update-applicable-stores/${qrId}${
        isCache ? "?cache=true" : ""
      }`,
      data
    )
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateQrReminder = (qrId, data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/qr-code/update-reminders/${qrId}${isCache ? "?cache=true" : ""}`,
      data
    )
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateQrTheme = (qrId, data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/qr-code/update-landing-page/${qrId}${isCache ? "?cache=true" : ""}`,
      data
    )
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const updateQrCreative = (qrId, data, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(
      `/v1/qr-code/update-creative/${qrId}${isCache ? "?cache=true" : ""}`,
      data
    )
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const activateQrCode = (qrId, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/qr-code/activate/${qrId}`, data)
      .then((res) => {
        dispatch(setQrCodeData(res.data.payload));

        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const setQrCodeImg = (data) => (dispatch) => {
  dispatch({
    type: GENERATE_QR_CODE,
    payload: data,
  });
};

export const generateQrCode = (qrId, isCache) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/qr-code/generate-qr-code/${qrId}${isCache ? "?cache=true" : ""}`
    )
      .then((res) => {
        dispatch(setQrCodeImg(res.data.payload));
        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

// insights

export const getQrSummary = (entityId, qrCodeId, query) => () => {
  const period = query?.period?.key;
  const end = query?.period?.endDate?.format("YYYY-MM-DD");
  const start = query?.period?.startDate?.format("YYYY-MM-DD");

  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/qr-code/qr-code-summary/${entityId}${
        qrCodeId ? `/${qrCodeId}` : ""
      }${period ? `?period=${period}` : ""}${start ? `&start=${start}` : ""}${
        end ? `&end=${end}` : ""
      }`
    )
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getQrCodeList = (entityId, query) => () => {
  const status = query?.status;
  const page = query?.page || 1;
  const limit = query?.limit || 5;
  const period = query?.period?.key;
  const sortType = query?.sortType || 0;
  const template_id = query?.template_id;
  const end = query?.period?.endDate?.format("YYYY-MM-DD");
  const start = query?.period?.startDate?.format("YYYY-MM-DD");

  const url = `/v1/qr-code/qr-code-list/${entityId}?page=${page}&limit=${limit}&sortType=${sortType}&period=${period}&start=${start}&end=${end}${
    status ? `&status=${status}` : ""
  }${template_id ? `&template_id=${template_id}` : ""}`;

  return new Promise((resolve, reject) => {
    Api.post(url)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getQrStorePerformance = (entityId, query) => () => {
  const page = query?.page || 1;
  const limit = query?.limit || 5;
  const qrCodeId = query?.qrCodeId;

  const url = `/v1/qr-code/store-wise-performance/${entityId}${
    qrCodeId ? `/${qrCodeId}` : ""
  }?page=${page}&limit=${limit}`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => resolve(res.data.payload))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getQrCustomerList = (qrId, entityId, query) => () => {
  const page = query?.page || 1;
  const limit = query?.limit || 15;
  const status = query?.status || "";
  const segment = query?.segment || "";
  const customer_id = query?.customer_id || "";

  const isExportQuery = query?.isAttachment || false;

  const period = query.period?.key;
  const end = query.period?.endDate?.format("YYYY-MM-DD");
  const start = query.period?.startDate?.format("YYYY-MM-DD");

  const url = `/v1/qr-code/customer-list/${qrId}/${entityId}?page=${page}&limit=${limit}${
    customer_id ? `&customer_id=${customer_id}` : ""
  }${segment ? `&segment=${segment}` : ""}${status ? `&filter=${status}` : ""}${
    period && `&period=${period}`
  }${start && `&start=${start}`}${end && `&end=${end}`}${
    isExportQuery ? "&attachment=true" : ""
  }`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => resolve(isExportQuery ? res : res.data.payload))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getPublicLoyalty = (storeId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/qr-code/loyalty/${storeId}`)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const scanQrCustomer = (qrId, data, isCache) => () => {
  return new Promise((resolve, reject) => {
    Api.post(
      `/v1/qr-code/scan-customer/${qrId}${isCache ? "?cache=true" : ""}`,
      data
    )
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const checkProfileCompletionStatus = (entityId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`v1/qr-code/customer/profile-completion-status/${entityId}`, data)
      .then((res) => {
        return resolve(res.data.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const checkCustomerRewards = (entityId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`v1/qr-code/customer/rewards/${entityId}`, data)
      .then((res) => {
        return resolve(res.data.payload || res.data);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error(errObj.msg)
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const deleteDraftOrCacheQr = (qrId, entityId, isCache) => () => {
  return new Promise((resolve, reject) => {
    Api.delete(`/v1/qr-code/delete/${qrId}/${entityId}${isCache ? "?cache=true" : ""}`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Failed to delete the draft."
        );
        return reject(err);
      });
  });
};
